export default __webpack_public_path__ + "static/media/contentBoxEl.b4ed8d18.svg";